import { AxiosRequest } from 'src/lib/axios/Axios';

export type OrdersCsvParams = {
  search?: string;
  statusId?: string; // (= payment_state)
  userId?: string; // "-1" o id de cuenta
  startDate?: string;
  endDate?: string;
  order_state_id?: string;
  retail?: string;
  marketplace?: string;
  orderBy?: string;
  direction?: string;
  promotion?: string;
};

export const downloadOrdersCsv = async (params: OrdersCsvParams) => {
  const resp = await AxiosRequest.get('/orders-export/csv', {
    params,
    responseType: 'blob',
  });
  return resp;
};
